import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Container, Form } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import CustomTooltip from "utils/CustomTooltip";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import { RouterContext } from "./Onboarding";
import jsDig from "utils/jsDig";
import DataPullSavePopUp from "../utils/DataPullSavePopUp";
export default function DataPull(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);
  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);
  props.pageLocator();

  const pullResetter = () => {
    return props.pullBoxes
      .filter(
        (platform, idx) =>
          !(
            platform[0] == "Google: SEO" ||
            platform[0] == "Google Search Console" ||
            platform[0] == "SEMRush" ||
            (platform[0] == "Shopify" && jsDig(["website_platform"], props.client_account) != "0")
          )
      )
      .map((newItem) => {
        newItem[2] = false;
        return newItem;
      });
  };

  const pullUpdateHelper = (idx, newValue) => {
    let newArray = props.pullBoxes;
    newArray[idx][2] = newValue;
    props.setPullBoxes([...newArray]);
  };
  const [showBoxes, setShowBoxes] = useState(false);
  const [validated, setValidation] = useState(false);
  const ppcPullboxes = props.pullBoxes.slice(0, 2).concat(props.pullBoxes.slice(5, props.pullBoxes.length));
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container fluid className="px-0 px-lg-5">
      <Row className="px-0 px-lg-4 mb-3 pb-3 justify-content-center">
        <Col md={10}>
          <Row className="mb-1  justify-content-center">
            <Col md={9}>
              <div>
                <p className="pb-3 f28 visby-bold primary text-center">Pull PPC Data</p>
              </div>
              <div>
                <p className=" f16 nunito-regular  primary ">Would you like to pull data from your accounts now?</p>
              </div>
            </Col>
          </Row>
          <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
          <Row className="mb-3 pb-3 justify-content-center">
            <Col md={9}>
              <div className="pb-1 pt-2">
                <CustomTooltip
                  faClass="far fa-question-circle pb-1 f16 text-info pt-1 pr-2"
                  message={
                    "Doing this will pull the data from the platforms you’ve configured now. Data may take a little while to pull, and you can continue onboarding while the data pulls in the background"
                  }
                  inline={true}
                />{" "}
                <span className=" f16 text-info ">What does this mean?</span>
              </div>
              <div className="d-flex flex-column ">
                <Form.Check
                  className="f16"
                  name="ob-pull-data"
                  custom
                  label="Yes I would like to pull data now."
                  type="radio"
                  id="ob-yes-pull"
                  onClick={() => {
                    setShowBoxes(true);
                    setValidation(false);
                  }}
                />
                <Form.Check
                  name="ob-pull-data"
                  className="f16"
                  custom
                  label="No, do not pull data."
                  type="radio"
                  id="ob-no-pull"
                  onClick={() => {
                    setShowBoxes(false);
                    setValidation(true);
                    pullResetter();
                  }}
                />
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <div className={showBoxes === false ? "d-none" : undefined}>
        <Row className="justify-content-center">
          <Col md={7}>
            <p className="f16 mb-4">For which accounts?</p>
            <div className="my-3 platform-list">
              {props.pullBoxes.map((platform, idx) => {
                let show = true;
                if (platform[0] == "Google: SEO" || platform[0] == "Google Search Console" || platform[0] == "SEMRush") show = false;
                if (platform[0] == "Shopify" && jsDig(["website_platform"], props.client_account) != "0") show = false;
                if (platform[0] == "Google Ads") show = jsDig(["google_ads", "enabled"], props.search_section.platform_data);
                if (platform[0] == "Microsoft Ads") show = jsDig(["microsoft_ads", "enabled"], props.search_section.platform_data);
                if (platform[0] == "Google: Video") show = props.video_section.enabled;
                if (platform[0] == "Google: Display") show = props.display_section.enabled;
                if (platform[0] == "Facebook") show = props.social_section.enabled;
                const visible = show ? "flex " : "none";
                return (
                  <div key={platform[0]} className=" pb-2 justify-content-start" style={{ display: visible }}>
                    <CustomFormCheck
                      id={`ob-${platform[0]}`}
                      name={`[pull_platform_data]${platform[1]}`}
                      label={platform[0]}
                      checked={platform[2]}
                      onChange={() => {
                        pullUpdateHelper(idx, !platform[2]);

                        if (show) {
                          let exist = ppcPullboxes.find((el) => el.includes(true));

                          if (exist == undefined) setValidation(false);
                          else setValidation(true);
                        }
                      }}
                    />
                  </div>
                );
              })}
            </div>
            <p className="font-weight-bold text-danger">Clicking next will initiate a large data pull which could take several hours to complete.</p>
          </Col>
        </Row>
      </div>
      <Row className="mt-5">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={() => {
                showBoxes ? setOpen(true) : props.submitForm(nextPage.url);
                // props.manualDataPull();
              }}
            // onClick={() => setOpen(true)}
            />
            <DataPullSavePopUp
              nextPage={nextPage.url}
              onboarding={true}
              manualDataPull={props.manualDataPull}
              submitForm={props.submitForm}
              open={open}
              handleClose={handleClose}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
